import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider, RequireAuth } from './lib/auth.tsx';
import LandingPage from './routes/LandingPage.tsx';
import LoginPage from './routes/LoginPage.tsx';
import AuthCallbackPage from './routes/AuthCallbackPage.tsx';
import DashboardPage from './routes/DashboardPage.tsx';
import ExperimentNewPage from './routes/ExperimentNewPage.tsx';
import ExperimentPage from './routes/ExperimentPage.tsx';
import ExperimentEditPage from './routes/ExperimentEditPage.tsx';
import NotFoundPage from './routes/NotFoundPage.tsx';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route element={<RequireAuth />}>
            <Route path="/app" element={<DashboardPage />} />
            <Route path="/app/experiments/new" element={<ExperimentNewPage />} />
            <Route path="/app/experiments/:id" element={<ExperimentPage />} />
            <Route path="/app/experiments/:id/edit" element={<ExperimentEditPage />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
